import React from 'react'
import { Bag } from '@components/icons'
import { useCartItemsCount } from '@components/alfakher/pylot-cart-manager/src/hooks/use-cart-items-count'
import { useUI } from '@corratech/pylot-ui/context'
import { useCart } from '@corratech/pylot-cart-manager'
import { Button } from '@corratech/pylot-ui'
import { useIsMobile } from '@components/common/IsMobile/useIsMobile'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import s from './FloatingCartIcon.module.scss'

export const FloatingCartIcon = (): JSX.Element | null => {
    const { data: cartData } = useCart()
    const { t } = useTranslation()
    const { toggleSidebar } = useUI()
    const isMobile = useIsMobile()
    const cartItemsCount = useCartItemsCount(cartData?.data?.cart?.items)
    if (isMobile && cartItemsCount) {
        return (
            <div className={cn(s['floating-cart'])}>
                <Button
                    className={cn(s['bag-btn'])}
                    variant="link"
                    onClick={toggleSidebar}
                    aria-label={t('Bag')}
                >
                    <Bag />
                    <span className={cn(s['cart-count'])}>
                        {cartItemsCount}
                    </span>
                </Button>
            </div>
        )
    }
    return null
}

export default FloatingCartIcon
